const STORAGE_KEY = "org_settings";

const DEFAULTS = {
  primary_color: "#1a73e8",
  secondary_color: "#34a853",
  accent_color: "#ea4335",
  background_color: "#ffffff",
};

const CSS_MAP = {
  primary_color: "--primary-color",
  secondary_color: "--secondary-color",
  accent_color: "--accent-color",
  background_color: "--background-color",
};

export function useOrgSettings() {
  function load() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? { ...DEFAULTS, ...JSON.parse(raw) } : { ...DEFAULTS };
    } catch {
      return { ...DEFAULTS };
    }
  }

  function save(settings) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
    applyToRoot(settings);
  }

  function applyToRoot(settings) {
    const merged = { ...DEFAULTS, ...settings };
    const root = document.documentElement;
    Object.entries(CSS_MAP).forEach(([key, cssVar]) => {
      root.style.setProperty(cssVar, merged[key]);
    });
  }

  function applyFromStorage() {
    const settings = load();
    applyToRoot(settings);
  }

  return { load, save, applyToRoot, applyFromStorage, DEFAULTS };
}
